import { render } from "./expertise-component.vue?vue&type=template&id=412742dc&scoped=true"
import script from "./expertise-component.vue?vue&type=script&lang=js"
export * from "./expertise-component.vue?vue&type=script&lang=js"

import "./expertise-component.vue?vue&type=style&index=0&id=412742dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412742dc"]])

export default __exports__